var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBillingInfoIcon = function SvgBillingInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 38 37"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M3.583 15.417h30.834"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18.306 31.604h-7.878c-5.473 0-6.86-1.357-6.86-6.768V12.164c0-4.903 1.14-6.475 5.442-6.722.432-.015.91-.03 1.418-.03h17.128c5.473 0 6.86 1.356 6.86 6.767v6.799"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M9.75 24.667h6.167M34.417 27.75c0 1.156-.324 2.25-.895 3.176a6.12 6.12 0 0 1-5.272 2.99 6.12 6.12 0 0 1-5.273-2.99 6.045 6.045 0 0 1-.894-3.176 6.165 6.165 0 0 1 6.167-6.167 6.165 6.165 0 0 1 6.167 6.167Z",
    opacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B3B2B2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m26.5 30 2-2 2 2m0-4-2 2-2-2"
  })));
};
export default SvgBillingInfoIcon;